import { combineReducers } from 'redux';

import { dialogClosed, dialogOpened } from 'Core/actions/dialog.ts';
import { createReducersFromShorthands } from 'Core/reducers/common.ts';

const initStates = {
  extractorData: null,
  opened: [],
};

export default combineReducers(
  createReducersFromShorthands(
    {
      opened: {
        [dialogOpened]: (state, { payload }) =>
          state.includes(payload) || payload === 'VehicleWidgetDialog' ? state : [...state, payload],
        [dialogClosed]: (state, { payload }) =>
          payload === 'VehicleWidgetDialog' ? state : state.slice(0, -1),
      },
      extractorData: {
        [dialogOpened]: (state, { meta: { extractorData } }) => extractorData ?? state,
        default: () => initStates.extractorData,
      },
    },
    initStates,
  ),
);
